import {
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppButton from "../../components/app-button/AppButton";
import AppDialogDelete from "../../components/app-dialog-delete/AppDialogDelete";
import AppTable from "../../components/app-table/AppTable";
import Iconify from "../../components/iconify/Iconify";
import {
  categoryAction,
  categoryDelete,
  getCategories,
} from "../../reduxStore/slices/categorySlice";
import { useNotify } from "../../utils/snackbarUtils";

function CategoriesList(props) {
  const tableHead = [
    { id: "name", label: "Category Name", align: "left" },
    { id: "status", label: "Status", align: "center" },
    { id: "createdAt", label: "Created At", align: "left" },
    { id: "actions", label: "Actions", align: "center", width: "120px" },
  ];

  const { showSuccess, handleApiError, showError } = useNotify();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { list, loading: isLoading } = useSelector((state) => state.category);

  const storeId = user?.storeId;
  const tableRows = list;

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const getAllCategories = async () => {
    try {
      await dispatch(getCategories({ storeId })).unwrap();
    } catch (err) {
      handleApiError(err);
    }
  };

  // Load categories
  useEffect(() => {
    if (storeId) {
      getAllCategories();
    }
  }, [storeId]);

  const handleAddCategory = () => {
    navigate("/app/config/category/add");
  };

  const handleDeleteClose = () => {
    setIsDeleteDialogOpen(false);
  };

  const toggleStatus = async (event, row) => {
    const obj = {
      store_id: storeId,
      uid: row.uid,
      id: row.id,
      record_status: event.target.value === "A" ? "D" : "A",
    };
    try {
      const res = await dispatch(categoryAction(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const handleDeleteConfirm = async () => {
    setIsDeleteDialogOpen(false);
    const obj = {
      store_id: storeId,
      uid: selectedRow.uid,
      id: selectedRow.id,
      record_status: "R",
    };
    try {
      const res = await dispatch(categoryDelete(obj)).unwrap();
      showSuccess(res.message);
    } catch (err) {
      handleApiError(err);
    }
  };

  const editActionClick = (e, row) => {
    setSelectedRow(row);
    navigate(`/app/config/category/edit/${row.uid}`);
  };

  const deleteActionClick = async (event, row) => {
    setIsDeleteDialogOpen(true);
    setSelectedRow(row);
  };

  return (
    <Box
      sx={{
        margin: "25px 60px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Tooltip title="Back to Configuration">
            <IconButton onClick={() => navigate("/app/config")}>
              <Iconify icon="eva:arrow-back-fill" width={24} height={24} />
            </IconButton>
          </Tooltip>

          <Typography variant="h5" gutterBottom>
            Categories
          </Typography>
        </Stack>
        <Link style={{ textDecoration: "none" }}>
          {tableRows.length > 0 && !isLoading && (
            <AppButton
              onClick={handleAddCategory}
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              New Category
            </AppButton>
          )}
        </Link>
      </Stack>
      <Box>
        <AppTable
          tableHead={tableHead}
          tableRows={tableRows}
          listType="categoryTables"
          searchPlaceholder="Search By Category Name"
          toggleSwitchStatus={toggleStatus}
          editActionClick={editActionClick}
          deleteActionClick={deleteActionClick}
          searchField={"name"}
          handleAddAction={handleAddCategory}
          emptyTitle="No categories available"
          emptyDesc="Add new category to get started."
          emptyButtonLabel="New Category"
          isLoading={isLoading}
        />
      </Box>

      {isDeleteDialogOpen && (
        <AppDialogDelete
          isOpen={isDeleteDialogOpen}
          id={"delete_category_dialog"}
          title={<>Delete Category</>}
          footer={
            <>
              <Button
                autoFocus
                onClick={handleDeleteConfirm}
                className="confirm-delete-btn"
              >
                Delete
              </Button>
              <Button
                onClick={handleDeleteClose}
                variant="outlined"
                className="cancel-delete-btn"
              >
                Cancel
              </Button>
            </>
          }
        >
          <Typography
            style={{
              fontSize: 14,
              color: "#000",
            }}
          >
            Are you sure want to delete category?
          </Typography>
        </AppDialogDelete>
      )}
    </Box>
  );
}

export default CategoriesList;
